<template>
  <section>
    <!-- Botões -->
    <div class="row m-4">
      <button :class="['btn', 'btn-secondary', { 'active': cl === 'charts' }]" @click="setRT('charts')">
        <i class="fas fa-chart-pie"></i>
      </button>
      <button :class="['btn', 'btn-secondary', { 'active': cl === 'reports' }]" @click="setRT('reports')">
        <i class="fas fa-chart-bar"></i>
      </button>
      <button :class="['btn', 'btn-secondary', { 'active': cl === 'toogle' }]" @click="setRT('toogle')">
        <i class="fas fa-sync"></i>
      </button>
    </div>

    <!-- DASHBOARD ORIGINAL -->
    <div v-if="toogleRealtime" class="row">
      <div class="col-md-12 tab-one-wrapper">
        <form id="filter-charts">
          <div class="col-12 mb-3">
            <label class="font-weight-bold d-block mb-2">Filtro de Filas para os Gráficos</label>
            <div class="input-group queue-group">
              <div class="input-group-prepend">
                <span class="input-group-text icon-wrapper">
                  <i class="fas fa-chart-bar"></i>
                </span>
              </div>
              <div class="multiselect-wrapper">
                <multiselect v-model="selectedQueues" :options="queues" :multiple="true" :close-on-select="false"
                  :clear-on-select="false" :hide-selected="false" :preserve-search="false" :preselect-first="false"
                  :searchable="false" label="name" track-by="id" placeholder="Todas as filas"
                  :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                  :selected-label="'Selecionado'" :show-no-results="true" @input="onMultiselectChange">
                  <template #noResult>Nenhuma fila encontrada!</template>
                </multiselect>
              </div>
            </div>
          </div>
        </form>

        <div class="wrapper-charts">
          <PizzaChartAnswered :filter="chartFilterRealtime" />
          <PizzaChartAbandoned :filter="chartFilterRealtime" />
        </div>
      </div>

      <div class="col-md-12 tab-two-wrapper">
        <div class="wrapper-group">

          <div class="container-graficos">
            <div class="grafico1">
              <AverageTimeCalls type="serviceTime" :filter="chartFilterRealtime" />
            </div>
            <div class="grafico2">
              <AverageTimeCalls type="waitingTime" :filter="chartFilterRealtime" />
            </div>
          </div>
        </div>

        <div>
          <OperatorProductivityChart :filter="chartFilterRealtime" />
          <MixedChart :filter="chartFilterRealtime" />
        </div>
      </div>
    </div>

    <!-- FILTROS PARA NOVOS RELATÓRIOS -->
    <div v-if="cl === 'reports' || (cl === 'toogle' && !toogleRealtime)" class="px-5">
      <div class="row">
        <div class="col-md-6">
          <start-end-date-component id="dashboard" :required="true" :start="startDate" :end="endDate" type="date"
            @update:start="startDate = $event" @update:end="endDate = $event" />
        </div>

        <div class="col-md-6">
          <label class="font-weight-bold d-block mb-2">Filtro de Filas para os Relatórios</label>
          <div class="input-group queue-group">
            <div class="input-group-prepend">
              <span class="input-group-text icon-wrapper">
                <i class="fas fa-chart-bar"></i>
              </span>
            </div>
            <div class="multiselect-wrapper">
              <multiselect v-model="selectedQueuesReport" :options="queues" :multiple="true" :close-on-select="false"
                :clear-on-select="false" :hide-selected="false" :preserve-search="false" :preselect-first="false"
                :searchable="false" label="name" track-by="id" placeholder="Todas as filas"
                :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                :selected-label="'Selecionado'" :show-no-results="true" @input="onMultiselectChangeReport">
                <template #noResult>Nenhuma fila encontrada!</template>
              </multiselect>
            </div>

            <div class="input-group-append">
              <button class="btn btn-primary" @click="updateCharts">
                <i class="fa fa-search"></i>
              </button>
              <button class="btn btn-secondary" @click="resetFilters">
                <i class="fas fa-times-circle"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="(cl === 'reports' || (cl === 'toogle' && !toogleRealtime)) && !showNewCharts"
      class="alert alert-warning mx-5 mt-3" role="alert">
      <i class="fas fa-exclamation-circle"></i>
      Por favor, preencha os filtros acima e clique na lupa para gerar os relatórios.
    </div>

      <!-- NOVOS RELATÓRIOS -->
    <div v-if="(cl === 'reports' || (cl === 'toogle' && !toogleRealtime)) && showNewCharts">
      <div class="col-md-12 tab-two-wrapper">
        
        <!-- 1) PRIMEIRO: DONUT COMBINADO -->
        <div class="wrapper-charts">
          <CombinedDonutCallsReport :filter="filterPayload" />
        </div>

        <!-- 2) DEPOIS: BARRAS -->
        <div class="wrapper-charts">
          <CombinedBarCallsReport :filter="filterPayload" />
        </div>
        <!-- 3) MÉDIAS DE TEMPO -->
        <div class="wrapper-group">
          <!-- <div class="card-relatorio atendimento">
            <AverageTimeCallsReport type="serviceTime" :filter="filterPayload" />
          </div> -->
          <div class="card-relatorio espera">
            <AverageTimeCallsReport 
              type="waitingTime" 
              :filter="filterPayload" 
              :plot_options="plot_options"
            />
          </div>
        </div>

        <!-- 4) GAUGE -->
        <div class="wrapper-group">
          <GaugeChartCallsReport :filter="filterPayload" />
        </div>

      </div>
    </div>


  </section>
</template>


<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import AverageTimeCalls from "../charts/AverageTimeCalls.vue";
import OperatorProductivityChart from "../charts/OperatorProductivityChart.vue";
import MixedChart from "../charts/MixedChart.vue";
import PizzaChartAnswered from "../charts/PizzaChartAnswered.vue";
import PizzaChartAbandoned from "../charts/PizzaChartAbandoned.vue";

import BarChartAbandonedReport from "../charts/BarChartAbandonedReport.vue";
import BarChartAnsweredReport from "../charts/BarChartAnsweredReport.vue";
import DonutChartsCallsReport from "../charts/DonutChartsCallsReport.vue";
import GaugeChartCallsReport from "../charts/GaugeChartCallsReport.vue";
import AverageTimeCallsReport from "../charts/AverageTimeCallsReport.vue";
import CombinedBarCallsReport from "../charts/CombinedBarCallsReport.vue";
import CombinedDonutCallsReport from "../charts/CombinedDonutCallsReport.vue";

export default {
  name: "DashboardApp",
  components: {
    AverageTimeCalls,
    OperatorProductivityChart,
    MixedChart,
    PizzaChartAnswered,
    PizzaChartAbandoned,
    BarChartAbandonedReport,
    BarChartAnsweredReport,
    CombinedDonutCallsReport,
    CombinedBarCallsReport,
    GaugeChartCallsReport,
    AverageTimeCallsReport,
    Multiselect,
  },
  data() {
    return {
      toogleRealtime: true,
      intervalId: "",
      cl: "charts",
      chartFilterRealtime: "*",
      chartFilterReport: "*",
      showNewCharts: false,
      queues: [],
      selectedQueues: [],
      selectedQueuesReport: [],
      queueIdToName: {},
      startDate: "",
      endDate: "",
      filterPayload: {
        startDate: "",
        endDate: "",
        queue: "*",
        queueIds: "*"
      },
      plot_options: {
         bar: {
          distributed: true,
          horizontal: false,
          columnWidth: '55%',
          borderRadius: 5,
          borderRadiusApplication: 'end',
          dataLabels: {
            position: 'top',
          },
        },      
      }, 
    };
  },
  mounted() {
    // this.startToogleInterval();
    this.fetchQueues();
    // this.setDefaultDates();
  },
  methods: {
    setRT(style) {
      this.cl = style;
      clearInterval(this.intervalId);

      if (style === "charts") {
        this.toogleRealtime = true;
        // não zera showNewCharts
      } else if (style === "reports") {
        this.toogleRealtime = false;
        // não zera showNewCharts
      } else if (style === "toogle") {
        this.startToogleInterval();
      }
    },
    startToogleInterval() {
      this.intervalId = setInterval(() => {
        this.toogleRealtime = !this.toogleRealtime;
        // não zera showNewCharts
      }, 15000);
    },
    async fetchQueues() {
      try {
        const { data } = await axios.get("dashboard/getQueuesByUser");
        this.queues = data;
        this.selectedQueues = [];
        this.selectedQueuesReport = [];
        this.chartFilterRealtime = "*";
        this.chartFilterReport = "*";
        this.queueIdToName = data.reduce((map, queue) => {
          map[queue.id] = queue.name;
          return map;
        }, {});
      } catch (error) {
        console.error("Erro ao buscar filas:", error);
      }
    },
    onMultiselectChange() {
      this.chartFilterRealtime = this.selectedQueues.length
        ? this.selectedQueues.map(q => q.id).join(',')
        : "*";
    },
    onMultiselectChangeReport() {
      this.chartFilterReport = this.selectedQueuesReport.length
        ? this.selectedQueuesReport.map(q => q.id).join(',')
        : "*";
    },
    // setDefaultDates() {
    //   const today = new Date();
    //   const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    //   this.startDate = firstDay.toISOString().split("T")[0];
    //   this.endDate = today.toISOString().split("T")[0];
    // },
    updateCharts() {
      let queueNames = [];
      let queueIds;

      if (this.chartFilterReport === "*") {
        // Todos: pega nomes de todas as filas
        queueNames = this.queues.map(q => q.name);
        // Aqui envia string '*' para os IDs
        queueIds = '*';
      } else {
        // Filas selecionadas
        const selectedIds = this.chartFilterReport.split(',');
        queueNames = selectedIds.map(id => this.queueIdToName[id]).filter(Boolean);
        // Envia os IDs como string separada por vírgula
        queueIds = this.chartFilterReport;
      }

      this.filterPayload = {
        startDate: this.startDate,
        endDate: this.endDate,
        queue: queueNames.join(','),
        queueIds: queueIds,
      };

      console.log('DashboardApp - filterPayload construído:', this.filterPayload);
      console.log('DashboardApp - Datas:', { startDate: this.startDate, endDate: this.endDate });
      console.log('DashboardApp - Filas:', { queueNames, queueIds });

      this.showNewCharts = true;
    },
    resetFilters() {
      this.chartFilterReport = "*";
      this.selectedQueuesReport = [];
      this.showNewCharts = false;
      this.setDefaultDates();
    },
  },
};
</script>


<style scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

.tab-one-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.wrapper-charts {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
  padding: 8px;
}

.tab-two-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.wrapper-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 32px;
  margin-top: 30px;
  padding: 0 20px;
}

.card-relatorio {
  flex: 1 1;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease;
  box-sizing: border-box;
}

.card-relatorio:hover {
  transform: scale(1.01);
}

.wrapper-chart {
  width: 100% !important;
}

.wrapper-chart h3 {
  font-size: 1.25rem;
  text-align: center;
  margin-bottom: 16px;
  font-weight: bold;
}

.card-relatorio.atendimento h3 {
  color: #1e7f5c;
}

.card-relatorio.espera h3 {
  color: #a65d00;
}

.container-graficos {
  display: flex;
  width: 100%;
  gap: 15px;
  /* Espaçamento horizontal */
  padding: 10px 0;
  box-sizing: border-box;
}

.container-graficos>div {
  flex: 1 1 0;
  max-width: 50%;
  min-width: 0;
}

.queue-group {
  display: flex;
  align-items: stretch;
  max-width: 100%;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  background-color: #228899;
  color: white;
  border-radius: 0.25rem 0 0 0.25rem;
  height: 100%;
}

.multiselect-wrapper {
  flex: 1;
}

.multiselect {
  width: 100%;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.multiselect__tags {
  min-height: 38px;
  height: 100%;
  border-radius: 0 0.25rem 0.25rem 0;
  display: flex;
  align-items: center;
  border: 1px solid #ced4da;
}

.multiselect__select {
  height: 38px;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}

.multiselect__content-wrapper {
  width: 100% !important;
  box-sizing: border-box;
}
</style>
